import React from 'react';
import { cyan } from '@material-ui/core/colors';

const SIZE = 80;

class Loading extends React.Component {

	render() {

	    const style = {
            position: 'fixed',
            top: '185px',
            right: this.props.right,
            width: SIZE + 'px',
            height: SIZE + 'px',
            color: '#fff',
            padding: '10px',
            borderRadius: '2px',
            fontSize: '14px',
            zIndex: 5000
	    };

		return(<div id="loading-overlay" style={style}>
		    <div id="box-wrap">
		        <div id="loading-box">
		            <svg width={SIZE + 'px'} height={SIZE + 'px'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" className="uil-ring-alt">
		            	<rect x="0" y="0" width={SIZE} height={SIZE} fill="none" className="bk"></rect>
		            	<circle cx="50" cy="50" r="40" stroke={'#427175'} fill="none" strokeWidth="14" strokeLinecap="round"></circle>
		            	<circle cx="50" cy="50" r="40" stroke="#ffffff" fill="none" strokeWidth="10" strokeLinecap="round">
		            		<animate attributeName="stroke-dashoffset" dur="2s" repeatCount="indefinite" from="0" to="502"></animate>
		            		<animate attributeName="stroke-dasharray" dur="2s" repeatCount="indefinite" values="150.6 100.4;1 250;150.6 100.4"></animate>
		            	</circle>
		            </svg>
		        </div>
		    </div>
		</div>);
	}
}

export {Loading}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/components/loading/index.js